var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(-5357 -2899)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(45 1676)",
    fill: "#1d252c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5357 2899)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5400 -4573)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 1678.645)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.874V18.011A2.792,2.792,0,0,0,2.786,20.8h9a2.792,2.792,0,0,0,2.786-2.786v-1.8a.552.552,0,1,0-1.1,0v1.8A1.691,1.691,0,0,1,11.783,19.7h-9A1.691,1.691,0,0,1,1.1,18.011V6.874A1.691,1.691,0,0,1,2.786,5.187h9a1.691,1.691,0,0,1,1.687,1.687v1.8a.552.552,0,1,0,1.1,0v-1.8a2.792,2.792,0,0,0-2.786-2.786H2.786A2.789,2.789,0,0,0,0,6.874Z",
    transform: "translate(0 -4.088)",
    fill: "#1d252c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.342,18.8a.552.552,0,0,0,.781,0l3.765-3.765a.547.547,0,0,0,0-.776l-3.765-3.765a.549.549,0,0,0-.776.776l2.827,2.827H14.858a.552.552,0,0,0,0,1.1H25.169l-2.827,2.827A.542.542,0,0,0,22.342,18.8Z",
    transform: "translate(-5.049 -6.291)",
    fill: "#1d252c"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSair);
export default __webpack_public_path__ + "static/media/sair.d3abd1de9ac2cb6baeda077ed1ab882c.svg";
export { ForwardRef as ReactComponent };